import { hrefOf } from '../overview/href'
import { useQuery } from '@tanstack/react-query'
import { aiActionsQuery } from '../api/opteemum'
import { Spinner } from '../ui/Spinner'
import type { ScreenProps } from './screens'

/**
 * Filele AI Actions / redZone (setup_protection.php). Citirea e identica;
 * POST-urile kit raman in CI3.
 */

const KIND: Record<string, string> = {
  'opteemum/setupProtection/': 'setupProtection',
  'opteemum/tuneUp/': 'tuneUp',
  'opteemum/diagnosisRepairProtection/': 'diagnosisRepairProtection',
  'opteemum/restoreOptimize/': 'restoreOptimize',
  'opteemum/virusRemovalProtection/': 'virusRemovalProtection',
}

export function DeviceAiActions({ id, href, open }: ScreenProps & { href?: string }) {
  const kind = KIND[href ?? ''] ?? 'setupProtection'
  const { data, error } = useQuery(aiActionsQuery(id, kind))

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {error.message}
      </div>
    )
  }
  if (!data) return <Spinner />

  return (
    <div className="row">
      <div className="col-md-12">
        <ul className="nav nav-tabs line-tabs mb-2 managementList" role="tablist">
          {data.tabs.map((tab) => (
            <li key={tab.href}>
              <a
                href={hrefOf(`${tab.href}${id}`) ?? '#'}
                onClick={(e) => {
                  e.preventDefault()
                  open(tab.href)
                }}
              >
                <i className={tab.icon} aria-hidden="true"></i> {tab.label}
              </a>
            </li>
          ))}
        </ul>
        <div className="tab-content"></div>
      </div>
    </div>
  )
}

export function DeviceSetupProtection(props: ScreenProps) {
  return <DeviceAiActions {...props} href="opteemum/setupProtection/" />
}

export function DeviceTuneUp(props: ScreenProps) {
  return <DeviceAiActions {...props} href="opteemum/tuneUp/" />
}

export function DeviceDiagnosisRepair(props: ScreenProps) {
  return <DeviceAiActions {...props} href="opteemum/diagnosisRepairProtection/" />
}

export function DeviceRestoreOptimize(props: ScreenProps) {
  return <DeviceAiActions {...props} href="opteemum/restoreOptimize/" />
}

export function DeviceVirusRemoval(props: ScreenProps) {
  return <DeviceAiActions {...props} href="opteemum/virusRemovalProtection/" />
}
